import React, { useEffect } from "react";
import "./index.css";

import Header from "./components/Header/Header";
import { ArcGISMap, Toolbar, useStore as useLibStore } from "mcmap-lib";
import { AppConfig } from "./app.config.ts";
import { ModalRoot } from "mcmap-lib/src/components/Modals/ModalRoot";
export default function App() {

  const { setConfig } = useLibStore();
  // Initialize the store with the app config
  useEffect(() => {
    setConfig(AppConfig);
  }, []);

  return (
    <>
      <ModalRoot />
      <div className="h-screen w-screen flex flex-col overflow-hidden">
        <Header
          title={AppConfig.header.title}
          subtitle={AppConfig.header.subtitle}
        />
        <Toolbar options={AppConfig.toolbarOptions} />
        <ArcGISMap config={AppConfig} />
      </div>
    </>
  );
}
